module.exports = __webpack_public_path__ + "static/media/player-attacking.3e3db14d.png";